import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const excludedUSRegions = [
  {
    name: 'American Samoa',
    shortCode: 'AS',
  },
  {
    name: 'Micronesia',
    shortCode: 'FM',
  },
  {
    name: 'Guam',
    shortCode: 'GU',
  },
  {
    name: 'Marshall Islands',
    shortCode: 'MH',
  },
  {
    name: 'Northern Mariana Islands',
    shortCode: 'MP',
  },
  {
    name: 'Palau',
    shortCode: 'PW',
  },
  {
    name: 'Puerto Rico',
    shortCode: 'PR',
  },
  {
    name: 'Virgin Islands',
    shortCode: 'VI',
  },
  {
    name: 'Armed Forces Americas',
    shortCode: 'AA',
  },
  {
    name: 'Armed Forces Europe, Canada, Africa and Middle East',
    shortCode: 'AE',
  },
  {
    name: 'Armed Forces Pacific',
    shortCode: 'AP',
  },
];

export const msawEmailDomainToExclude = '@ms.amilearn.ca';

export enum JoinFlowStep {
  STEP_1 = 'STEP_1',
  STEP_2 = 'STEP_2',
  STEP_3 = 'STEP_3',
  PROCESSING = 'PROCESSING',
  FINISH_REGISTRATION = 'FINISH_REGISTRATION',
  ERROR = 'ERROR',
}

export enum FormGroupName {
  firstStep = 'firstStep',
  secondStep = 'secondStep',
  thirdStep = 'thirdStep',
}

export enum FormControlName {
  // First Step
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  password = 'password',

  // Second Step
  city = 'city',
  province = 'province',
  country = 'country',
  zipCode = 'zipCode',
  employer = 'employer',
  jobTitle = 'jobTitle',

  // Third Step
  termsAndConditions = 'termsAndConditions',
}

export interface Country {
  value: string;
  viewValue: string;
}

export enum CountryCode {
  CA = 'CA',
  US = 'US',
  MERGED = 'MERGED',
}

export function createNameValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = (control.value as string).trim();

    const [minLen, maxLen] = [1, 64];
    const lenTest = minLen <= value.length && value.length <= maxLen;

    const charTest = /\S+/gi.test(value);
    return !charTest || !lenTest ? { incorrect: true } : null;
  };
}

export function createOneRequiredCharacterValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const value = (control.value as string).trim();
    return value.length > 0 ? null : { incorrect: true };
  };
}
